import { merge } from 'lodash-es';
import jsonParseSafe from '@/common/utils/jsonParseSafe';
import { NotificationType } from '@/common/constants/common.constants';

const BASE_CONFIG = {
  app_env: process.env.NODE_ENV,
  // whether leaveCounter.mixin is disabled
  disable_idle_timeout: typeof window !== 'undefined' ? window.top !== window : false,
  notificationDuration: {
    [NotificationType.WARNING]: 5 * 1000,
    [NotificationType.ERROR]: 10 * 1000,
    [NotificationType.SUCCESS]: 3 * 1000,
    [NotificationType.INFO]: 3 * 1000,
    [NotificationType.PROGRESS]: 0,
  },
  telemetry: {
    apiKey: 'phc_MvQGox1xbRNrJDpylvNtYp3hf72LRjP2xqxj1PrfHzS',
    host: '/t/',
    debug: process.env.NODE_ENV === 'development'
  }
};

// window.EXTERNAL_CONFIGURATION is used by 3d party libraries (test runners, browser addons) to specify behaviour
const externalConfig = typeof window !== 'undefined' && window.EXTERNAL_CONFIGURATION
  ? jsonParseSafe(window.EXTERNAL_CONFIGURATION)
  : {};

export default merge(BASE_CONFIG, externalConfig);
